module.exports = __webpack_public_path__ + "img/purple-rectangle-table-8.28644399.png";